import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../generic-components/Icon';
import crownIcon from '../../../assets/icons/svg/large-icons/ic-large-crown.svg';
import Heading from '../../../generic-components/Heading';

export const MasterOfCategorization = () => {
  const { t } = useTranslation();
  return (
    <div className='flex flex-col items-center justify-center h-full w-full'>
      <Icon className='w-[30%] mb-[14px]' src={crownIcon} />
      <Heading id='masterOfCategorizeTitle' title={t('CATEGORIZE_EXPENSES_COMPONENT_MASTER_LINE1')} className='text-center font-metricMedium text-[14px] text-bw06 mb-[4px]' />
      <Heading id='masterOfCategorizeContent' title={t('CATEGORIZE_EXPENSES_COMPONENT_MASTER_LINE2')} className='text-center font-metric text-[12px] text-bw05 max-w-[240px]' />
    </div>
  );
};
